import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Alert from 'react-bootstrap/Alert';
import lodash from 'lodash';
import { updateInStorage } from '../../utils/get-location/location-from-storage';
import './ChatBot.css';
import { isAudioInputQuestion } from '../OnBoarding/utils';
import AudioInput from '../OnBoarding/audioComponent/Timer';
import loadingGif from '../../images/loading.gif';
import useTranslation from '../../hooks/use-translation';
import ShowButton from './ShowButton/ShowButton';
import config from '../../config.json';
import { post_vaccine_covid_survey_v1 as post_vac_survey_id } from '../OnboardingWrapper';

let text;
const RenderSingleSelect = ({
  msg, handleSingleSelectClick, index, count
}) => {
  let inner_output = msg.options.map(option => (
    <div key={option.id} className="flexButton">
      <input
        style={{ background: '#eeeeee' }}
        className="check-box"
        type="button"
        key={option.id}
        value={option.preferred_term}
        id={option.id}
        variant="outline-secondary"
        disabled={count - index !== 1}
        onClick={handleSingleSelectClick}
      />
    </div>));
  inner_output = <div className="buttonControl">{inner_output}</div>;
  return (inner_output);
};
const RenderUserInput = ({
  handleUserInputChange, handleUserInputClick, count, index, err, t
}) => (
    <>
      <div className="inputControl">
        <InputGroup>
          <FormControl
            aria-describedby="basic-addon2"
            onChange={handleUserInputChange}
          />
          <InputGroup.Append>
            <input type="button" value={t("NEXT")} style={{ background: '#039073' }} className="buttonList" disabled={count - index !== 1} onClick={handleUserInputClick} />
          </InputGroup.Append>
        </InputGroup>
      </div>
      <div className="errorControl">
        {err}
      </div>
    </>
  );
const RenderMultiSelect = ({
  msg, count, index, err, current, handleMultiSelectChange, handleMultiSelectClick, t
}) => {
  const arr2 = msg.options;
  let inner_output = msg.options.map((option, ind2) => (
    <div key={`multi_select_${option.id}`} className="flexbutton2">
      <input type="button" className="check-box" key={option.id} style={{ background: (lodash.find(current, { id: option.id })) ? '#034ea1' : '#eeeeee', color: (lodash.find(current, { id: option.id })) ? 'white' : '#7f7f7f' }} id={option.id} value={option.preferred_term} label={option.preferred_term} onClick={e => handleMultiSelectChange(e, ind2, arr2)} />
    </div>
  ));
  inner_output = <div className="buttonControl">{inner_output}</div>;
  const next = <input type="button" value={t("NEXT")} style={{ background: '#034ea1' }} className="buttonList" disabled={count - index !== 1} onClick={handleMultiSelectClick} />;
  return (
    <Form>
      {inner_output}
      {next}
      <div className="errorControl">{err}</div>
    </Form>
  );
};

const RenderAudioInput =
  /* istanbul ignore next */
  ({ msg, onAnswerSelected }) => (
    <AudioInput
      question={msg}
      onSubmit={apiResponse => {
        onAnswerSelected(apiResponse)();
      }}
    />
  );

const RenderQuestions = ({
  msg, err, current, count, index, handleMultiSelectChange, handleUserInputChange, handleSingleSelectClick, handleMultiSelectClick, handleUserInputClick, onAnswerSelected, t
}) => {
  let inner_output;
  if (msg.selection_type === 'Single-Select') {
    inner_output = <RenderSingleSelect msg={msg} handleSingleSelectClick={handleSingleSelectClick} index={index} count={count} />;
  } else if (msg.selection_type === 'Number') {
    inner_output = <RenderUserInput handleUserInputChange={handleUserInputChange} count={count} index={index} handleUserInputClick={handleUserInputClick} err={err} t={t} />;
  } else if (isAudioInputQuestion(msg)) {
    inner_output = <RenderAudioInput msg={msg} onAnswerSelected={onAnswerSelected} />;
  }
  else {
    inner_output = <RenderMultiSelect msg={msg} count={count} index={index} err={err} current={current} handleMultiSelectChange={handleMultiSelectChange} handleMultiSelectClick={handleMultiSelectClick} t={t} />;
  }
  return (inner_output);
};

const RenderSelected = ({
  msg, heading, selected, index
}) => {
  if (msg.selection_type === 'Number') {
    return ([<>
      {' '}
      {heading}
      <div className="box4 sb13">{selected[index]}</div>
    </>]);
  }

  const sel = selected.slice();
  const arr = sel[index];
  const len = arr.length;
  const res_arr = arr.map((vals, ind) => {
    const selected_option = msg.options.find(option => option.id == vals.id);
    if (ind < len - 1) return (`${selected_option.preferred_term}, `);
    return (selected_option.preferred_term);
  });
  return ([<>
    {' '}
    {heading}
    <div className="box4 sb13">{res_arr}</div>
  </>]);
};

const getAdvisoryFromResults = msg => {
  const results = msg.results;
  if (!results) return '';
  const { meta_data = {} } = results;
  const { analytics_data = {} } = meta_data;
  const { advisory = [''] } = analytics_data;
  return advisory[0];
};

const getRiskFromResults = msg => {
  const results = msg.results;
  const severity = lodash.get(results, "meta_data.display_data.risk_advisory.severity", "");
  const risk = lodash.get(results, "meta_data.analytics_data.risk_display_category", "");
  return {
    severity,
    risk
  }
}

export default ({ question, questions, onAnswerSelected, isNoChange, sourceId, noComputeRiskResponse, surveyEndMessage, workflowId }) => {
  const [count, setCount] = useState(questions.length);
  const [current, setCurrent] = useState([]);
  const [err, setErr] = useState();
  const [selected, setSelected] = useState([]);
  const [first_time, setFirst] = useState(true);
  const { t } = useTranslation();

  const message = React.createRef();
  if (first_time) {
    text = '';
    setFirst(false);
  }
  // function to scroll to bottom
  const scrollToBottom = () => {
    message.current.scrollIntoView({ behavior: 'smooth' });
  };
  // effect to scroll to bottom when content is added
  useEffect(() => {
    scrollToBottom();
  });
  // handling change in checkboxes
  const handleMultiSelectChange = (e, i, ops) => {
    let cur = current.slice();
    const index = lodash.findIndex(cur, { id: e.target.id });
    const ind = lodash.findIndex(questions[questions.length - 1].options, { id: e.target.id });
    const obj = questions[questions.length - 1].options[ind];
    if (ops[i].clear_others && !lodash.find(cur, obj)) {
      cur = [obj];
      setErr();
    } else if (index > -1) {
      cur.splice(index, 1);
    } else {
      cur.push(obj);
      const removable = [];
      for (let ind = 0; ind < cur.length; ind++) if (cur[ind].clear_others) removable.push(ind);
      for (let ind = removable.length - 1; ind >= 0; ind--)cur.splice(removable[ind], 1);
      setErr();
    }
    setCurrent(cur);
  };
  //handling change in text area
  const handleUserInputChange = e => {
    text = e.target.value;
    let addEntered = e.target.value.replace(/[^0-9]/g, '') || '';
    if (addEntered > 100) { e.target.value = ''; addEntered = ''; }
    updateInStorage(questions[questions.length - 1].question_id, addEntered);
    const cur = current.slice();
    cur.push(addEntered);
    setCurrent(cur);
    if (parseInt(text) === parseInt(text, 10) && !isNaN(text)) setErr();
    else {
      setErr(
        <>
          <br />
          <Alert variant="danger" className="errorControl">
            <p className="errorDisplay">Please enter a valid age</p>
          </Alert>
        </>
      );
    }
  };
  //handling single select
  const handleSingleSelectClick = e => {
    const obj = { preferred_term: e.target.value, id: e.target.id };
    const new_count = lodash.cloneDeep(count);
    const new_select = selected.slice();
    new_select.push([obj]);
    setSelected(new_select);
    setCount(new_count + 1);
    const index = lodash.findIndex(questions[questions.length - 1].options, { id: e.target.id });
    onAnswerSelected(questions[questions.length - 1].options[index])();
  };
  //handling multi-select
  const handleMultiSelectClick = e => {
    const cur = current.slice();
    if (cur.length === 0) {
      setErr(
        <>
          <br />
          <Alert variant="danger" className="errorControl">
            <p className="errorDisplay">No option selected</p>
          </Alert>
        </>
      );
      setCurrent([]);
    } else {
      const new_count = lodash.cloneDeep(count);
      const new_select = selected.slice();
      const selectionOptions = cur.map(selectedoption => (selectedoption.id));
      onAnswerSelected(selectionOptions)();
      new_select.push(cur);
      setCurrent([]);
      setErr();
      setSelected(new_select);
      setCount(new_count + 1);
    }
  };
  //handling text area input
  const handleUserInputClick = () => {
    if ((parseInt(text) === parseInt(text, 10)) && !isNaN(text)) {
      const new_count = lodash.cloneDeep(count);
      setErr();
      const new_select = selected.slice();
      new_select.push([text]);
      setSelected(new_select);
      setCount(new_count + 1);
      const selectionOptions = current.slice();
      onAnswerSelected(text)();
    } else {
      setErr(
        <>
          <br />
          <Alert variant="danger" className="errorControl">
            <p className="errorDisplay">Please enter a valid age</p>
          </Alert>
        </>
      );
    }
    setCurrent([]);
  };

  if (typeof (questions[questions.length - 1]) !== 'undefined') {
    return (
      <>
        <div style={{ backgroundColor: 'white' }}>
          <ListGroup className="paddingBottomSmall marginBottom63px" >
            {
              questions.map((msg, index) => {
                if (questions[index].loading === true) {
                  return (
                    <div className="box3" >
                      <img src={loadingGif} alt="loading..." />
                    </div>
                  )
                }
                const heading = <div className="box3">{msg.question_text}</div>;
                let inner_output = [];
                // displaying current question

                if (question === null && index === questions.length - 1 && !noComputeRiskResponse && workflowId!==post_vac_survey_id) {
                  return (
                    <>
                      {isNoChange ? <div><div className="box3">
                        {t('NO_CHANGE_UNABLE_TO_CLOSE')}
                        <br />
                      </div>
                        <br />
                        <br />
                        <input type="button" value={t('DONE')} style={{ background: '#039073' }} className="buttonList" disabled={count - index !== 1} onClick={() => window.close()} />
                      </div>
                        :
                          <ShowButton sourceId={sourceId} severity={getRiskFromResults(msg).severity} >
                          <div className="box3">
                            {t('RISK_TITLE')}
                            <br />
                            <span className={`${getRiskFromResults(msg).severity}`}>{getRiskFromResults(msg).risk}</span>
                            <br />
                          </div>
                          <div className="box3">
                            {t('RECOMMENDATION')}{":"}
                            <br />
                            {getAdvisoryFromResults(msg)}
                            <br />
                          </div>
                          <div className="box3">
                            {t('SOURCE_OF_RECOMMENDATION') || "Source of Recommendation"}{":"}
                            <br />
                            <a target="_blank" href={config.icmr_testing_source}>ICMR Guidelines</a>
                            <br />
                          </div>  
                          </ShowButton>
                      }
                    </>
                  );
                }
                else if (question === null && index === questions.length - 1 && !noComputeRiskResponse && workflowId === post_vac_survey_id) {
                  return (
                    <>
                      <ShowButton sourceId={sourceId} severity={getRiskFromResults(msg).severity} >
                        <div className="box3">{surveyEndMessage}</div>  
                      </ShowButton>
                    </>
                  )
                }
                else if (question === null && index === questions.length - 1 && noComputeRiskResponse) {
                  return (
                    <>
                      <ShowButton sourceId={sourceId} severity={getRiskFromResults(msg).severity} >
                        <div className="box3">{surveyEndMessage}</div>  
                      </ShowButton>
                    </>
                  )
                }
                if (index === count - 1) {
                  inner_output = <RenderQuestions
                    msg={msg} err={err}
                    count={count}
                    index={index}
                    current={current}
                    handleMultiSelectChange={handleMultiSelectChange}
                    handleUserInputChange={handleUserInputChange}
                    handleSingleSelectClick={handleSingleSelectClick}
                    handleMultiSelectClick={handleMultiSelectClick}
                    handleUserInputClick={handleUserInputClick}
                    onAnswerSelected={onAnswerSelected}
                    t={t}
                  />;
                  return (
                    <div key={`inner_output_${index}`}>
                      {heading}
                      <br />
                      <div className="msgDisplay">{inner_output}</div>
                    </div>
                  );
                }
                return (<RenderSelected msg={msg} heading={heading} selected={selected} index={index} />);
              })
            }
          </ListGroup>
          <div ref={message} />
        </div>
      </>
    );
  }
  return (
    <>
      <div ref={message} />
    </>
  );
};

